import React from "react";
import { ModeRendererProps } from "./types";

export function DiamondMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#diamond)" />
      <g transform="translate(397 540)">
        {Array.from({ length: 12 }).map((_, i) => (
          <rect
            key={i}
            x={-40 - i * 26}
            y={-40 - i * 26}
            width={80 + i * 52}
            height={80 + i * 52}
            fill="none"
            stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
            strokeWidth={i % 2 ? 2 : 1}
            opacity={0.7 - i * 0.05}
          />
        ))}
      </g>
    </g>
  );
}
